import { render, staticRenderFns } from "./MonthlyHistoryCard.vue?vue&type=template&id=cb0b5684&scoped=true"
import script from "./MonthlyHistoryCard.vue?vue&type=script&lang=js"
export * from "./MonthlyHistoryCard.vue?vue&type=script&lang=js"
import style0 from "./MonthlyHistoryCard.vue?vue&type=style&index=0&id=cb0b5684&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb0b5684",
  null
  
)

export default component.exports